import { SPEAKER_COLORS } from '../constants';
import { hashString } from './editor';
import i18n from '../i18n';

export function getSpeakerColor(speaker) {
  const hash = Math.abs(hashString(speaker));
  return SPEAKER_COLORS[hash % SPEAKER_COLORS.length];
}

export function getSpeakerInitials(speaker) {
  if (
    speaker.startsWith('SPEAKER_') ||
    speaker.startsWith(`${i18n.t('Talare')} `)
  ) {
    let num = speaker
      .replace('SPEAKER_', '')
      .replace(`${i18n.t('Talare')} `, '');
    num = parseInt(num, 10);
    if (!num) return '1';
    return num.toString().slice(0, 2);
  }

  const words = speaker
    .trim()
    .replace(/[\[\](){}!.?]/g, '')
    .split(' ');

  if (words.length > 1) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }

  return words?.[0]?.[0]?.toUpperCase();
}
